import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { confirmAlert } from 'react-confirm-alert';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './ShopFeaturesAddNewButton.scss';

import { addShopFeature } from '../../../APIClient/featured';
import { getGMTTime } from '../../../Helpers/formatting';
import { syncShopFeatures } from '../../../Actions/FeaturedActions';

import ConfirmPrompt from '../../General/ConfirmPrompt';

const ShopFeaturesAddNewButton = props => {
  const { type, featured } = props;
  const { shopSectionLabels } = featured;

  const sortInputField = {
    label: 'Add To End Of List',
    isBoolean: true,
    value: 'addToEnd',
    preloaded: true
  };
  const shopSectionLabelInputs =
    shopSectionLabels?.length > 0
      ? shopSectionLabels.map(label => ({
          label,
          isBoolean: true,
          value: label,
          preloaded: true
        }))
      : [];

  let apiType,
    adminInputFields = [];
  if (['curator', 'curators', 'user', 'users'].includes(type)) {
    apiType = 'curator';
    adminInputFields = [
      {
        display: 'Username',
        value: 'username',
        isSingleLine: true
      },
      ...shopSectionLabelInputs,
      sortInputField
    ];
  } else if (['circles', 'group', 'circle', 'groups'].includes(type)) {
    apiType = 'group';
    adminInputFields = [
      {
        display: 'Group ID',
        value: 'CuratorGroup_id',
        isSingleLine: true
      },
      ...shopSectionLabelInputs,
      sortInputField
    ];
  } else if (['catalog', 'category', 'department', 'categories', 'departments'].includes(type)) {
    apiType = 'catalog';
    adminInputFields = [
      {
        display: 'Category or Department Name',
        value: 'name',
        isSingleLine: true
      },
      {
        display: 'or Category ID (more precise)',
        value: 'Category_id',
        isSingleLine: true
      },
      {
        display: 'or Department ID (more precise)',
        value: 'Department_id',
        isSingleLine: true
      },
      ...shopSectionLabelInputs,
      sortInputField
    ];
  } else if (['brand', 'brands'].includes(type)) {
    apiType = 'brand';
    adminInputFields = [
      {
        display: 'Brand Name',
        value: 'name',
        isSingleLine: true
      },
      {
        display: 'or All Brand ID (more precise)',
        value: 'AllBrand_id',
        isSingleLine: true
      },
      ...shopSectionLabelInputs,
      sortInputField
    ];
  }

  const addFeature = () => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmPrompt
          header={`Add Featured ${type}`}
          onCancel={onClose}
          customInputFields={adminInputFields}
          submitMustReturnTrueToClose
          onSubmitAwait={async responseValues => {
            try {
              await addShopFeature({
                type: apiType,
                sortOrderRank: responseValues.addToEnd ? getGMTTime() : getGMTTime() * -1,
                ...responseValues
              });
              window.ALERT.success('Featured Added');
              props.syncShopFeatures();
              return true;
            } catch (error) {
              window.ALERT.error(error);
              return false;
            }
          }}
        />
      )
    });
  };

  return (
    <div onClick={addFeature} className='shop-features-add-new-button'>
      <FontAwesomeIcon icon={faPlus} />
      Featured {_.startCase(props.type)}
    </div>
  );
};

ShopFeaturesAddNewButton.propTypes = {
  type: PropTypes.oneOf([
    'brand',
    'brands',
    'catalog',
    'category',
    'categories',
    'department',
    'departments',
    'curator',
    'group',
    'circle',
    'circles',
    'group',
    'groups'
  ]).isRequired
};

const mapStateToProps = state => {
  const { featured } = state;
  return { featured };
};

export default connect(mapStateToProps, {
  syncShopFeatures
})(ShopFeaturesAddNewButton);
